import PropTypes from 'prop-types';
import React from 'react';
import { Box, Flex, StarRating } from '@qga/roo-ui/components';
import TripAdvisorRating from 'components/TripAdvisorRating';
import useRatingTooltip from 'hooks/useRatingTooltip';

const PropertyRatings = ({ starRating, starRatingType, customerRating, showTooltip = true }) => {
  const ratingTooltip = useRatingTooltip({ ratingType: starRatingType, isEnabled: showTooltip });
  const notZeroRating = starRating !== 0;
  return (
    <Flex flexDirection="row" alignItems="center" my={2}>
      {notZeroRating && (
        <Box mr={2} data-testid="star-rating">
          <StarRating rating={starRating} ratingType={starRatingType} size={12} {...ratingTooltip} />
        </Box>
      )}
      {customerRating?.source === 'trip_advisor' && (
        <Box data-testid="tripadvisor-rating">
          <TripAdvisorRating ml={notZeroRating ? '' : '-6px'} rating={customerRating} small />
        </Box>
      )}
    </Flex>
  );
};

PropertyRatings.propTypes = {
  customerRating: PropTypes.object,
  starRating: PropTypes.number.isRequired,
  starRatingType: PropTypes.string.isRequired,
  showTooltip: PropTypes.bool,
};

PropertyRatings.defaultProps = {
  customerRating: {},
};

export default PropertyRatings;
